import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const InformationTechnologyHeader = ({ componentData }) => {
  // Use componentData from CMS if available, otherwise use defaults
  const title = componentData?.title || "Information";
  const subtitle = componentData?.subtitle || "Technology";
  const content = componentData?.content || "Innovate. Create. Transform.";
  const backgroundImage = componentData?.mediaUrl || "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=2072&q=80";

  return (
    <CourseHeader
      title={title}
      highlight={subtitle}
      subtitle={content}
      backgroundImage={backgroundImage}
      cta={{ label: "Start Application", targetId: "application-form" }}
    />
  );
};

export default InformationTechnologyHeader;
